export const app = {
  box: {
    sizing: 'border-box',
  },
  font: {
    family: 'Inter',
  },
  mono: {
    font: {
      family: 'JetBrainsMono',
    },
  },
  bg: {
    color: '#f4f6ff',
  },
}
